export default __webpack_public_path__ + "static/media/EUIAC.dd23c43b.png";